<template>
    <div id="searchable-health" class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <h1 id="crbg-header">SEARCHABLE HEALTH LIBRARY</h1>
                <img src="/images/crbg/searchable-health/header_image.jpg" class="embed-responsive" alt="Main learning image"/>
            </div>
        </div>
        <div class="form-inline">
            <input
                class="search-input form-control"
                placeholder="Search keyword or phrase"
                type="text"
                v-model="search"
                v-on:keyup.enter="searchRequest"
                name="search-input"
            />
            <button class="search-button form-control btn btn-light" title="search" @click="searchRequest"/>
        </div>
        <span class="search-result" v-if="searched">{{ shlData.length }} results found</span>
        <div v-for="row in shlData" class="row-block">
            <span class="row-block_title"><a :href="'/searchable-health-library/' + row.contentMeta.id" title="Redirect to Library Page">{{ row.title }} </a>  </span>
            <span class="row-block_snippet" v-html="row.snippet || row.summary">  </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SBSearchableHealthLibrary",
    data() {
        return {
            search: '',
            searched: false,
            shlData: [],
        }
    },
    methods: {
        searchRequest() {
            this.$http.post('/api/search-shl', {
                search: this.search
            }).then(response => {
                this.shlData = response.body;
                this.searched = true;
            })
        },
    },
}
</script>

<style scoped>

</style>
